(() => {
  const root = document.querySelector('[data-hallowvia-favorites-page]');
  if (!root || !window.HallowviaFavorites) return;

  const grid = root.querySelector('[data-hallowvia-favorites-grid]');
  const loading = root.querySelector('[data-hallowvia-favorites-loading]');
  const empty = root.querySelector('[data-hallowvia-favorites-empty]');
  const error = root.querySelector('[data-hallowvia-favorites-error]');
  const rootUrl = `${root.dataset.rootUrl || ''}/`.replace(/\/{2,}/g, '/');
  let renderVersion = 0;

  const setVisible = (element, visible) => {
    if (element) element.hidden = !visible;
  };

  const render = async () => {
    const version = ++renderVersion;
    const handles = window.HallowviaFavorites.get();
    setVisible(loading, handles.length > 0);
    setVisible(empty, handles.length === 0);
    setVisible(error, false);
    if (handles.length === 0) {
      grid.replaceChildren();
      return;
    }

    const cards = await Promise.all(
      handles.map(async (handle) => {
        try {
          const url = `${rootUrl}products/${encodeURIComponent(handle)}?section_id=hallowvia-favorite-card`;
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) return null;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          return documentFragment.querySelector('[data-hallowvia-favorites-card]');
        } catch (_error) {
          return null;
        }
      })
    );

    if (version !== renderVersion) return;
    const availableCards = cards.filter(Boolean);
    grid.replaceChildren(...availableCards);
    setVisible(loading, false);
    setVisible(empty, availableCards.length === 0 && handles.length === 0);
    setVisible(error, availableCards.length < handles.length);
    window.HallowviaFavorites.sync(grid);
  };

  document.addEventListener('hallowvia:favorites:change', (event) => {
    if (event.detail?.action === 'removed' && event.detail.handle) {
      root
        .querySelector(`[data-hallowvia-favorites-card][data-product-handle="${CSS.escape(event.detail.handle)}"]`)
        ?.remove();
      if (event.detail.count === 0) {
        setVisible(empty, true);
        setVisible(error, false);
      }
      return;
    }
    render();
  });
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
  render();
})();
